import { array, create, Infer, number, string, type } from 'superstruct';

export const CropFormatValidator = type({
  label: string(),
  width: number(),
  height: number(),
});
export const CropFormatListValidator = array(CropFormatValidator);

export function makeCropFormatList(raw: unknown) {
  let list: Infer<typeof CropFormatListValidator> = [];
  try {
    list = create(raw, CropFormatListValidator);
  } catch (err) {
    console.error(err);
  }
  return list;
}
